import { Capacitor } from "@capacitor/core";
import { AppLauncher } from "@capacitor/app-launcher";
import { Browser } from "@capacitor/browser";

/**
 * Resolve push notification url (absolute or site-relative).
 */
export function resolveNotificationUrl(url, constants) {
  if (typeof url !== "string") return null;
  const trimmed = url.trim();
  if (!trimmed) return null;

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  if (trimmed.startsWith("/")) {
    const base =
      constants?.AppUrl ||
      constants?.lambdaApiServer ||
      (typeof window !== "undefined" ? window.location.origin : "");
    if (!base) return null;
    return String(base).replace(/\/$/, "") + trimmed;
  }

  return null;
}

export function isValidNotificationUrl(url, constants) {
  const resolved = resolveNotificationUrl(url, constants);
  if (!resolved) return false;
  try {
    const parsed = new URL(resolved);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function isValidNotificationImageUrl(url, constants) {
  return isValidNotificationUrl(url, constants);
}

/**
 * Open notification link — AppLauncher on native, Browser fallback (same as NotificationService).
 */
export async function openNotificationUrl(url, constants) {
  const resolved = resolveNotificationUrl(url, constants);
  if (!resolved) return false;

  try {
    if (Capacitor.isNativePlatform() && AppLauncher?.openUrl) {
      const res = await AppLauncher.openUrl({ url: resolved });
      if (res?.completed) return true;
    }
  } catch (e) {
    console.warn("[openNotificationUrl] AppLauncher.openUrl failed", e);
  }

  try {
    await Browser.open({ url: resolved });
    return true;
  } catch (e) {
    console.warn("[openNotificationUrl] Browser.open failed", e);
  }

  if (typeof window !== "undefined") {
    window.open(resolved, "_blank", "noopener,noreferrer");
    return true;
  }

  return false;
}
